import React, { useState } from 'react';
import { Box, Link, Text, Flex } from '@chakra-ui/react';

interface HoverLinkProps {
	text: string;
	link?: string;
	color: string;
	isRainbow?: boolean;
	direction?: string;
	icon?: JSX.Element;
}

const colors = [
	'#EF4444',
	'#F59E0B',
	'#10B981',
	'#3B82F6',
	'#6366F1',
	'#8B5CF6',
	'#EC4899',
	'#F87171',
	'#FBBF24',
	'#34D399',
	'#60A5FA',
	'#818CF8',
	'#A5B4FC',
	'#D53F8C',
	'#F472B6',
	'#F97316',
	'#22C55E',
];

const HoverLink = (props: HoverLinkProps) => {

	const [bgColor, setBgColor] = useState(props.color);

	const handleMouseEnter = () => {
	if (props.isRainbow) {
		const randomColor = colors[Math.floor(Math.random() * colors.length)];
		setBgColor(randomColor);
	}

};

  return (
    <Box
		position="relative"
		display="inline-block"
		onMouseEnter={handleMouseEnter}
		_hover={{
			'.hover-background': { transform: 'scaleX(1)' },
			'.hover-text': { color: 'white' },
			'.hover-icon': { color: 'white' },
		}}
    >
		<Link href={props.link} isExternal _hover={{ textDecoration: 'none' }}>
			<Flex
				alignItems="center"
				gap={props.icon ? 5 : 0}
				padding={props.icon ? 2 : 0}
			>
				{props.icon && (
				<Box
					className="hover-icon"
					fontSize="4xl"
					zIndex={1}
					transition="color 0.2s ease-in-out"
					color={props.color}
				>
					{props.icon}
				</Box>
				)}
				<Text
					color={props.color}
					position="relative"
					zIndex={1}
					transition="color 0.2s ease-in-out"
					className="hover-text"
				>
					{props.text}
				</Text>
			</Flex>

			<Box
				position="absolute"
				top="0"
				left="0"
				width="100%"
				height="100%"
				backgroundColor={props.isRainbow ? bgColor : props.color}
				zIndex={0}
				transform="scaleX(0)"
				transformOrigin={props.direction || 'left'}
				transition="transform 0.2s ease-in-out"
				className="hover-background"
			/>

		</Link>
    </Box>
  );
};

export default HoverLink;
